import request from '@/utils/request'
import URL from '@/api/urlTranslator'
// 业务文档保存
export function execBatchSave(data) {
  return request({
    url: URL.seaExport.execBatchSave,
    method: 'post',
    data
  })
}

// 业务文档保存
export function updateContractFunc(data) {
  return request({
    url: URL.seaExport.updateContractUrl,
    method: 'post',
    data
  })
}

// 业务文档
export function findBusinessDocument(data) {
  return request({
    url: URL.seaExport.findBusinessDocument,
    method: 'post',
    data
  })
}

// 进仓照片发邮件
export function sendPhotoMail(data) {
  return request({
    url: URL.seaExport.sendPhotoMail,
    method: 'post',
    data
  })
}

// 全部上传文件历史
export function uploadFileHistory(params) {
  return request({
    url: URL.warehouseIn.uploadFileHistoryUrl,
    method: 'post',
    params
  })
}

// 获取指定 documentCategory 文档种类的最近一次的上传云存储编号
export function queryLastFileDocumentId(params) {
  return request({
    url: URL.seaExport.queryLastFileDocumentId,
    method: 'get',
    params
  })
}
